import type { FaireProductEntity } from "../../entity_types/product";

export const p_gm2u52fdcv: FaireProductEntity = {
  token: "p_gm2u52fdcv",
  type: "product",
  name: "Matches in Tin - Geranium",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/0cc5c1f25a24a47e12c8ce99d287b920d013d13895000a1390076c7c5d878cea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d3e468ecbc95d0144ef56248eebe20cd69819fc83d8e5702a092c7d27b6228d0.jpeg",
    "https://cdn.faire.com/fastly/be651589d60c07900907c71b62c9c44441dc6cec9d00a89ceb6487a72a3ae8fb.jpeg",
  ],
  priceDollars: 8.5,
  description:
    'These Geranium Safety Matches are housed in a reusable sliding tin featuring delicate botanical artwork inspired by vintage floral studies and pressed flower collections. The soft pink and green palette brings a fresh decorative touch to shelves, desks, and bedside spaces alike.\n\nContaining 100 safety matches with soft lilac tips, each tin features striker paper housed within a custom brass holder on the front of the tin, combining everyday practicality with vintage-inspired design. Designed to be refilled and reused, it makes a thoughtful gift for gardeners, flower lovers, and anyone drawn to botanical interiors.\n\nContains 100 safety matches. Keep away from children, heat, sparks, and open flames. Store in a dry place.\n\nSize: 12cm H x 8.5cm W x 2.5cm D | 4.72" H x 3.35" W x 0.89" D',
  tags: [],
  msrpDollars: 19,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:35.735Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
